document.addEventListener('DOMContentLoaded', () => {
    // Dynamic copyright year in the footer transmission line
    document.getElementById('copyright-year').textContent = new Date().getFullYear();

    // Serve images from the R2 bucket (custom domain) in production, but from the
    // local Parcel-bundled copies during development — so `pnpm dev` works offline
    // and shows image edits before they're uploaded. Each swap keeps the bundled
    // copy as a fallback if the remote asset fails to load.
    const LOCAL_HOSTS = ['localhost', '127.0.0.1', '0.0.0.0', ''];
    const ASSET_BASE = LOCAL_HOSTS.includes(location.hostname)
        ? ''
        : 'https://assets.latentsignal.io';

    if (ASSET_BASE) {
        document.querySelectorAll('img[data-asset]').forEach((img) => {
            const fallback = img.src;
            img.addEventListener(
                'error',
                () => {
                    if (img.src !== fallback) img.src = fallback;
                },
                { once: true },
            );
            img.src = `${ASSET_BASE}/${img.dataset.asset}`;
        });
    }

    /* ---- Screenshot lightbox ------------------------------------------------
       Ported from the Cove landing page (~/code/cove/landing/app.js), adapted
       to this page's markup: no <figure>/<figcaption> here, so the capture's
       own alt text becomes the caption.

       The grid shows a 480px thumbnail at roughly 150px wide, which is far too
       small to read. Each `.shot-open` is a real <a href> to a separate 1920px
       capture, so with JS off the browser simply navigates to that image; here
       we intercept the click and show it in a <dialog> instead.
       `showModal()` carries the modal semantics, the focus trap, and Esc; the
       rest is ours. */

    const openers = document.querySelectorAll('.shots .shot .shot-open');
    // No usable <dialog> means we leave every anchor alone, and each one keeps
    // working as the plain link it already is.
    const dialogReady =
        typeof HTMLDialogElement === 'function' &&
        typeof HTMLDialogElement.prototype.showModal === 'function';
    if (!openers.length || !dialogReady) return;

    const root = document.documentElement;
    let box = null;
    let opener = null;

    const lockPage = () => {
        // Measured before the lock: the difference is the width a classic
        // scrollbar is about to give up. Zero with macOS overlay scrollbars.
        root.style.setProperty('--scrollbar-gutter', window.innerWidth - root.clientWidth + 'px');
        root.classList.add('has-lightbox');
    };
    const unlockPage = () => {
        root.classList.remove('has-lightbox');
        root.style.removeProperty('--scrollbar-gutter');
    };

    const build = () => {
        const dialog = document.createElement('dialog');
        dialog.className = 'lightbox';
        dialog.setAttribute('aria-labelledby', 'lightbox-caption');

        const inner = document.createElement('div');
        inner.className = 'lightbox-inner';

        const figure = document.createElement('figure');
        figure.className = 'lightbox-figure';

        const image = document.createElement('img');
        image.className = 'lightbox-img';
        image.setAttribute('alt', '');
        image.setAttribute('decoding', 'async');

        const caption = document.createElement('figcaption');
        caption.className = 'lightbox-caption';
        caption.id = 'lightbox-caption';

        figure.append(image, caption);
        inner.appendChild(figure);

        const close = document.createElement('button');
        close.type = 'button';
        close.className = 'lightbox-close';
        close.autofocus = true;
        close.setAttribute('aria-label', 'Close the full size screenshot');
        close.innerHTML =
            '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false">' +
            '<path d="M3 3l10 10M13 3L3 13" fill="none" stroke="currentColor" ' +
            'stroke-width="1.7" stroke-linecap="round"/></svg>';

        dialog.append(inner, close);

        const onVeil = (el) => !!el && !el.closest('.lightbox-figure, .lightbox-close');
        // Both ends of the gesture must land on the veil, so a drag that starts
        // on the capture and releases outside it doesn't read as a dismissal.
        // A keyboard activation leaves `pressed` null and never dismisses here.
        let pressed = null;
        dialog.addEventListener('pointerdown', (e) => {
            pressed = e.target;
        });
        dialog.addEventListener('click', (e) => {
            const dismiss = onVeil(e.target) && onVeil(pressed);
            pressed = null;
            if (dismiss) dialog.close();
        });
        close.addEventListener('click', () => dialog.close());
        // Covers the close button, the veil, and Esc alike. The event is queued
        // rather than dispatched synchronously, so re-check that the dialog is
        // still shut before undoing anything.
        dialog.addEventListener('close', () => {
            if (dialog.open) return;
            unlockPage();
            if (opener) opener.focus();
            opener = null;
        });

        document.body.appendChild(dialog);
        return { dialog, image, caption };
    };

    const open = (link, alt) => {
        box = box || build();
        // Same hostname rule as the thumbnails above, and the same fallback:
        // the bundled copy is already this anchor's href.
        const bundled = link.href;
        box.image.onerror = () => {
            box.image.onerror = null;
            if (box.image.src !== bundled) box.image.src = bundled;
        };
        box.image.src =
            ASSET_BASE && link.dataset.fullAsset
                ? `${ASSET_BASE}/${link.dataset.fullAsset}`
                : bundled;
        box.image.alt = alt;
        box.caption.textContent = alt;
        // The anchor itself, not document.activeElement: Safari doesn't focus a
        // link on a plain mouse click, so activeElement here is usually <body>
        // and focus would never come back to the capture on close.
        opener = link;
        lockPage();
        box.dialog.showModal();
    };

    openers.forEach((link) => {
        const img = link.closest('.shot').querySelector('img');
        if (!img) return;
        link.addEventListener('click', (e) => {
            // Leave the modified clicks alone — cmd/ctrl-click, middle-click and
            // shift-click should still open the full capture in a tab or window.
            if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
            e.preventDefault();
            open(link, img.alt);
        });
    });
});
